import http from '../../http'

const API_URL = "procedure-documents"

/** Ítem 4.2.3 — Documentos propios de la empresa (subida libre). */
class ProcedureDocumentAPI {

  async getAll(companyId, page = 1, search = "") {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}&search=${search}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }
}

export default new ProcedureDocumentAPI()
